<h1 class="raportti-header">Tulos</h1>

@if (tulosEnsin) {
  <div class="tase-ensin">
    <app-button (click)="taseEnsinClicked.emit()" actionId="Tase ensin (näkymä)" additionalClass="report-btn tulos-ensin-button">
      <div>Tase ensin</div>
    </app-button>
  </div>
}

@if (tuloslaskelmanDataObservable | async; as data) {
  <ng-container style="position: relative">
    @if (!lataa()) {
      @if (data.e == 'a') {
        <div>Valittu päivämääräväli ei ole millään Lemonatorista löytyvällä tilikaudella.</div>
      }
      @if (lastSucessfullyUpdated()) {
        <div class="gray-text" style="font-size: 11px; text-align: left; margin-left: 5px; margin-top: 16px; line-height: 13px">Päivitetty {{ lastSucessfullyUpdated() | ltimestamptime | async }}</div>
      }
      <app-icon-button (click)="$event.stopPropagation()" [matMenuTrigger]="vertailuVuosiMenu" actionId="Avaa vertailuvuosi menu" styles="float: right;" matIcon="more_horiz"> </app-icon-button>
      @if (data.c == 'c2') {
        <table class="report-table">
          <thead>
            <tr>
              <th></th>
              <th>{{ data.c1Header }}</th>
              <th>{{ data.c2Header }}</th>
            </tr>
          </thead>
          <tbody>
            @for (row of data.data; track trackAccountRowByAccountNumberFn($index, row)) {
              <tr class="report-row-lvl-{{ row.l }}" [class.report-row-summary]="row.s">
                <td class="n">{{ row.n }}</td>
                <td>{{ row.s1 | number: '1.2-2' }}</td>
                <td>{{ row.s2 | number: '1.2-2' }}</td>
              </tr>
            }
          </tbody>
        </table>
      }
      @if (data.c == 'c1') {
        <table class="report-table">
          <thead>
            <tr>
              <th></th>
              <th>{{ data.c1Header }}</th>
            </tr>
          </thead>
          <tbody>
            @for (row of data.data; track trackAccountRowByAccountNumberFn($index, row)) {
              <tr class="report-row-lvl-{{ row.l }}" [class.report-row-summary]="row.s">
                <td class="n">{{ row.n }}</td>
                <td>{{ row.s1 | number: '1.2-2' }}</td>
              </tr>
            }
          </tbody>
        </table>
      }
    } @else {
      <mat-spinner style="margin-left: auto; margin-right: auto; margin-top: 20px"></mat-spinner>
    }
  </ng-container>
}

<mat-menu #vertailuVuosiMenu="matMenu" yPosition="above" xPosition="before">
  <ng-template matMenuContent>
    <app-menu-item-button (click)="vertailuTiedotKokoTilikaudenMukaan()" actionId="Valitse vertailutiedot (tulos): Näytä koko tilikausi">Näytä koko tilikausi</app-menu-item-button>
    <app-menu-item-button (click)="vertailuTiedotAjanjaksonMukaan()" actionId="Valitse vertailutiedot (tulos): Näytä ajanjakson mukaan">Näytä valitun aikavälin mukaan</app-menu-item-button>
  </ng-template>
</mat-menu>
